/**
* 菜单
*/
const menu = {
  
createMenuHouseGroup: "/api/createMenuHouseGroup",//创建
modifyMenuHouseGroup: "/api/modifyMenuHouseGroup",//修改
listMenuHouseGroup: "/api/listMenuHouseGroup",//查询
deleteMenuHouseGroup: "/api/deleteMenuHouseGroup",//删除
createMenuHouse: "/api/createMenuHouse",//创建
modifyMenuHouse: "/api/modifyMenuHouse",//修改
listMenuHouse: "/api/listMenuHouse",//查询
deleteMenuHouse: "/api/deleteMenuHouse",//删除
createMenu: "/api/createMenu",//创建
createMenu2: "/api/createMenu2",//创建
	modifyMenu: "/api/	modifyMenu",//修改
getMenu: "/api/getMenu",//查看用户菜单
getMyMenu: "/api/getMyMenu",//查看自身菜单
deleteMenu: "/api/deleteMenu",//删除
addMenuTemplate: "/api/addMenuTemplate",//新增菜单模板
modifyMenuTemplate: "/api/modifyMenuTemplate",//修改菜单模板
getMenuTemplates: "/api/getMenuTemplates",//查询菜单模板
deleteMenuTemplate: "/api/deleteMenuTemplate",//删除菜单模板
addMenuTemplateItem: "/api/addMenuTemplateItem",//新增菜单模板项
addMenuTemplateItems: "/api/addMenuTemplateItems",//新增菜单模板项
modifyMenuTemplateItem: "/api/modifyMenuTemplateItem",//修改菜单模板项
getMenuTemplateItems: "/api/getMenuTemplateItems",//查询菜单模板项
deleteMenuTemplateItems: "/api/deleteMenuTemplateItems",//删除菜单模板项
}

export default menu